import { Picture } from 'components/modulab/Picture';
import React from 'react';

export type ImageProps = {
  src: string | undefined | null;
  alt: string | undefined | null;
  /** Image height in px for calculating aspect ratio. */
  height?: number | undefined | null;
  /**
   * Image width in px for calculating aspect ratio and the maximum image
   * resolution.
   */
  width?: number | undefined | null;
  layout: 'responsive' | 'fill' | 'fixed';
  objectFit?:
    | 'contain'
    | 'cover'
    | 'fill'
    | 'none'
    | 'scale-down'
    | undefined
    | null;
  objectPosition?: string | undefined | null;
  /**
   * Approximate maximum display width (in px/vw/x). Used by the browser to
   * determine which resolution to download.
   */
  sizes?: string | undefined | null;
  loading?: 'lazy' | 'eager';
};

/**
 * A responsive image
 */
export function Image({
  alt = '',
  height,
  layout,
  objectFit,
  objectPosition,
  sizes,
  src,
  width,
  loading = 'lazy',
}: ImageProps): JSX.Element | null {
  return (
    <Picture
      alt={alt}
      layout={layout}
      loading={loading}
      objectFit={objectFit}
      objectPosition={objectPosition}
      sizes={sizes}
      source={{ _: { src, width, height } }}
    />
  );
}
